module.exports = __webpack_public_path__ + "img/icon-whatsapp.ffa06e6f.svg";